export const TextInputType = {
    TEXT: "text",
    EMAIL: "email",
    PASSWORD: "password",
    NUMBER: "number",
    CHECKBOX: "checkbox",
    DATEPICKER:"datepicker"
}

export const NumberValueType = {
    INT: "INT",
    DECIMAL: "DECIMAL",
}
